import React from 'react'
import { NavLink} from 'react-router-dom';
import { UseGlobelcourse } from './allcoursecontaxt/ALLCoursecontaxt';
import Formatprice from './Helper/Formatprice';
import { BASE_URL } from '../Config/Config';
import Course_Card from "../component/GlobelHelper/Course_Card";


function Gridview({allcourse}) {
    const {grid_view} =  UseGlobelcourse();
       console.log(allcourse);
       
  return (
   <>
     <div className={ grid_view ? "tab-pane fade active show" : "tab-pane fade"} id="tab-list" role="tabpanel" aria-labelledby="tab-shop-list">
            <div className="row gy-30">
        {
                 allcourse.map((curelm , index)=>(
                  
              <div className="col-md-6 col-xl-4 mt-4" key={index}>
                        <Course_Card  curdata={curelm}/>

                {/* <div className="course-box ">
                  <div className="course-img">
                    <img src={`${ BASE_URL}${curelm.CourseMaster_tumbimage}`} alt="img" />
                    <span className="tag"><i className="fas fa-clock" />{curelm.CourseMaster_duration} {curelm.CourseMaster_duration_unit}</span>
                  </div>

                  <div className="course-content">

                  <div className="course-rating">
                    <div
                   className="star-rating"
                   role="img"
                   aria-label={`Rated ${curelm.CourseMaster_rating} out of 5`}
                   >
                  <span style={{ width: `${(curelm.CourseMaster_rating / 5) * 100}%`, }}>
                  Rated <strong className="rating">{curelm.CourseMaster_rating}</strong> out of 5
                  </span>
                  </div>
                ({curelm.CourseMaster_rating})
                </div>

<h3 className="course-title">
  <NavLink to={`/course-detail/${curelm.id}`}>
    {curelm.CourseMaster_title.slice(0, 30)}{curelm.CourseMaster_title.length > 30 && '...'}
  </NavLink>
</h3>
                   
                    <div className="course-meta">
                      <span><i className="fal fa-file" />Lesson {curelm.course_lesson}</span>
                      <span><i className="fal fa-user" />Students {curelm.Number_of_students}</span>
                      <span><i className="fal fa-chart-simple" />{curelm.course_level}</span>
                    </div>
                    <div className="course-author">
                      <div className="author-info">
                        <img src="assets/img/course/author.png" alt="author" />
                        <NavLink to="/ourinstructer" className="author-name">{curelm.CourseMaster_Courseinstructor.CourseInstructor_name}</NavLink>
                      </div>
                      <div className="offer-tag">{curelm.CourseMaster_fee > 0 ? (<Formatprice price={curelm.CourseMaster_fee} />) : "Free"}
                      </div>
                    </div>
                  </div>
                </div> */}


              </div>
               ))}
            </div>
          </div>
   </>
  )
}

export default Gridview
